exports = module.exports = require("../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-carousel__button{width:80px;height:10px}.el-carousel__item:nth-child(2n){background-color:#093;background-image:url(" + require("../assets/images/welcome2.png") + ")}.el-carousel__item:nth-child(odd){background-image:url(" + require("../assets/images/welcome3.png") + ")}", "", {"version":3,"sources":["/./src/pages/welcome.vue"],"names":[],"mappings":"AACA,qBACI,WAAY,AACZ,WAAa,CAChB,AACD,iCACI,sBAAuB,AACvB,8CAAuD,CAC1D,AACD,kCACI,8CAAuD,CAC1D","file":"welcome.vue","sourcesContent":["\n.el-carousel__button {\n    width: 80px;\n    height: 10px;\n}\n.el-carousel__item:nth-child(2n) {\n    background-color: #093;\n    background-image: url(\"../assets/images/welcome2.png\");\n}\n.el-carousel__item:nth-child(2n+1) {\n    background-image: url(\"../assets/images/welcome3.png\");\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.25.0@css-loader?sourceMap!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-40131c78","scoped":false,"hasInlineConfig":false}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/pages/welcome.vue
// module id = 333
// module chunks = 0